import { useKioskStore } from '@/stores/kiosk-store'

export default function LanguageToggle({ position = 'bottom', flagsOnly = false }: { position?: 'bottom' | 'top'; flagsOnly?: boolean }) {
  const locale = useKioskStore((s) => s.locale)
  const setLocale = useKioskStore((s) => s.setLocale)

  if (flagsOnly) {
    return (
      <div className="flex items-center gap-2">
        <button
          onClick={() => setLocale('sv')}
          aria-label="Svenska"
          className={`kiosk-btn w-12 h-12 rounded-full flex items-center justify-center text-2xl transition-all ${locale === 'sv' ? 'ring-2 ring-kiosk-accent' : 'opacity-60'}`}
        >
          🇸🇪
        </button>
        <button
          onClick={() => setLocale('en')}
          aria-label="English"
          className={`kiosk-btn w-12 h-12 rounded-full flex items-center justify-center text-2xl transition-all ${locale === 'en' ? 'ring-2 ring-kiosk-accent' : 'opacity-60'}`}
        >
          🇬🇧
        </button>
      </div>
    )
  }

  return (
    <div className={`flex items-center justify-center gap-3 ${position === 'top' ? '' : 'py-3'}`}>
      <button
        onClick={() => setLocale('sv')}
        className={`kiosk-btn flex items-center gap-2 px-4 py-2.5 rounded-full text-base font-semibold transition-all ${
          locale === 'sv' ? 'bg-kiosk-accent text-kiosk-bg' : 'bg-kiosk-surface-2 text-kiosk-muted'
        }`}
      >
        <span className="text-lg">🇸🇪</span>
        Svenska
      </button>
      <button
        onClick={() => setLocale('en')}
        className={`kiosk-btn flex items-center gap-2 px-4 py-2.5 rounded-full text-base font-semibold transition-all ${
          locale === 'en' ? 'bg-kiosk-accent text-kiosk-bg' : 'bg-kiosk-surface-2 text-kiosk-muted'
        }`}
      >
        <span className="text-lg">🇬🇧</span>
        English
      </button>
    </div>
  )
}
